import faq from '@link/share/i18n/faq/ko';
import privacy from '@link/share/i18n/privacy/ko';
import terms from '@link/share/i18n/terms/ko';
import book from './book';
import booking from './booking';
import common from './common';
import law from './law';
import shinkansen from './shinkansen';

export default {
  ...common,
  views: {
    ...faq,
    ...privacy,
    ...terms,
    ...shinkansen,
    ...booking,
    ...book,
    ...law
  }
};
